import Head from 'next/head'
import {AnimatePresence, motion} from "framer-motion";

import {getParkFromSlug, getAllParkSlugs} from "@/lib/api";
import {capitalize, formatDate, formatPhoneNumber, slugify} from "@/lib/util";
import Image from "next/image";
import HeaderBanner from "@/components/HeaderBanner";
import ParkSubInfo from "@/components/ParkSubInfo";
import ThingsToDo from "@/components/ThingsToDo";
import Amenities from "@/components/Amenities";
import Articles from "@/components/Articles";


import {useRouter} from "next/router";
import LoaderSpinner from "@/components/LoaderSpinner";
import LoaderBar from "@/components/LoaderBar";
import useParkInfo from "@/components/useParkInfo";
import useScrollspy from '@/hooks/useScrollspy';
import {useEffect, useState} from "react";
import TableOfContents from "@/components/TableOfContents";
import ParkItem from "@/components/ParkItem";
import useSWR from "swr";

import {eventData} from '../../../json/events2';
import {getParkFromFullName, getParkFromParkCode} from "@/lib/data";
import {ArrowPathIcon, InformationCircleIcon, TicketIcon} from "@heroicons/react/24/outline";
import SmallInfo from "@/components/SmallInfo";
import Link from "next/link";


function SectionTitle({ title, className }) {
    return (
        <h2 id={slugify(title)} className={`text-2xl text-green-100 my-4 ${className}`}>
            <a href={`#${slugify(title)}`} className="hash-anchor" onClick={(e) => e.preventDefault()}></a>
            {title}
        </h2>
    )
}

export default function Event({ event }) {
   // console.log(event)
    const router = useRouter()
    const slug = router.query

    const activeSection = useScrollspy();

    const [toc, setToc] = useState();
    const minLevel = toc?.reduce((min, item) => (item.level < min ? item.level : min), 10) ?? 0;

    useEffect(() => {
        const headings = document.querySelectorAll('main h1, main h2');

        const headingArr = [];
        headings.forEach((heading) => {
            const id = heading.id;
            const level = +heading.tagName.replace('H', '');
            const text = heading.textContent + '';
            headingArr.push({ id, level, text });
        });
        setToc(headingArr)
    }, [event]);

    let category = event && event.category,
        dates = event && event.dates,
        dateStart = event && event.datestart,
        dateEnd = event && event.dateend,
        description = event && event.description,
        feeInfo = event && event.feeinfo,
        registerUrl = event && event.regresrrl,
        infoUrl = event && event.infoUrl,
        firstImage = event?.images?.[0]?.url ? `https://www.nps.gov${event?.images?.[0]?.url}` : null,
        //eventUrl = registerUrl ? registerUrl : infoUrl,
        eventUrl = event && `/event/${event.slug}`,
        recurrenceDateStart = event && event.recurrencedatestart,
        recurrenceDateEnd = event && event.recurrencedateend,
        parkFullName = event && event.parkfullname,
        times = event && event.times,
        timeEnd = times?.timeend,
        timeStart = times?.timestart,
        title = event && event.title,
        types = event && event.types,
        isRegistrationRequired = event && event.isregresrequired === 'true',
        isRecurring = event && event.isrecurring,
        parkCode = event && event.parkCode,
        park = getParkFromFullName(parkFullName),
        parkImage = park[0]?.images?.length ? park[0].images[0].url : null,
        image = firstImage || parkImage;

    // console.log('event', event)
    // console.log('park', park)
    // console.log('firstImage', firstImage)
    // console.log('parkImage', parkImage)

    return (
        <div className={``}>
            {/*max-w-8xl mx-auto px-4 sm:px-6 md:px-8 mt-5*/}
           <Head>
                <title>{event.title}</title>
            </Head>

            <HeaderBanner image={image} />

            <main className={`max-w-8xl mx-auto px-4 sm:px-6 md:px-8`}>

                <div className={`relative -mt-10 flex flex-wrap justify-between rounded bg-white max-md:p-8 md:p-10 max-w-8xl px-4 sm:px-6 md:px-8 pb-[55px] mx-auto`}>
                    <div className="flex max-md:flex-col w-full justify-between">
                        <div className="w-fit">
                            <motion.a
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.2 }}
                                className="text-brown-100/50 text-sm"
                                href={`/park/${park?.[0]?.slug}`}
                            >
                                {parkFullName}
                            </motion.a>
                            <motion.h1
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{ delay: 0.5 }}
                                className="text-3xl font-normal leading-tight text-brown-200"
                            >
                                {title}
                            </motion.h1>
                        </div>
                    </div>
                </div>

                {/*<div className={`-mt-10 bg-white p-10 rounded shadow-lg flex flex-wrap justify-between`}>*/}
                {/*    <div className={'lg:basis-4/5'}>*/}
                {/*        <motion.h1*/}
                {/*            initial={{ opacity: 0 }}*/}
                {/*            animate={{ opacity: 1 }}*/}
                {/*            transition={{ delay: 0.5 }}*/}
                {/*            className="text-3xl text-brown-200 leading-tight"*/}
                {/*        >*/}
                {/*            {title}*/}
                {/*        </motion.h1>*/}
                {/*        <Link href={`/park/${slugify(parkFullName)}`} className="text-xxs uppercase font-black text-brown-100/80 mt-4 lg:mt-0">*/}
                {/*            {parkFullName}*/}
                {/*        </Link>*/}
                {/*    </div>*/}

                {/*    <div className={'lg:basis-1/5'}>*/}
                {/*        /!*<p className={`text-sm mt-4 lg:mt-0`}>{category}</p>*!/*/}
                {/*        {types ?*/}
                {/*            <ul className={`flex flex-wrap mt-4`}>*/}
                {/*                {types.map((type, i) =>*/}
                {/*                    <li key={`${type}-${i}`}>*/}
                {/*                        <p className={`text-xxs my-1 py-1 pb-1 px-3 bg-beige-200 rounded-full mr-2`}>{type}</p>*/}
                {/*                    </li>*/}
                {/*                )}*/}
                {/*            </ul>*/}
                {/*            : null}*/}
                {/*    </div>*/}
                {/*</div>*/}

                <div className={`lg:grid lg:grid-cols-[auto,350px] lg:gap-8 mt-10`}>
                    <div className={'p-10 bg-white shadow-lg rounded'}>
                        <SectionTitle title="Info" className="sr-only" />

                        {event.description ?
                            <div dangerouslySetInnerHTML={{ __html: event.description}} className="mt-2 text-sm"></div>
                            : null}

                        {event.contactemailaddress || event.contactphonenumber ?
                            <ParkSubInfo title="Contact info">
                                {event.contactname ?
                                    <p>{event.contactname}</p>
                                    : null}

                                {event.contacttelephonenumber ?
                                    <p>
                                        <a href={`tel:${event.contacttelephonenumber}`}>
                                            {formatPhoneNumber(event.contacttelephonenumber)}
                                        </a>
                                    </p>
                                    : null}

                                {event.contactemailaddress ?
                                    <p>
                                        <a href={`mailto:${event.contactemailaddress}`}>
                                            {event.contactemailaddress}
                                        </a>
                                    </p>
                                    : null}

                            </ParkSubInfo>
                            : null}
                    </div>

                    <div className={'p-10 bg-white shadow-lg rounded'}>
                        <h2>Info</h2>
                        {isRecurring ?
                            <div className="flex uppercase text-xxs font-bold items-center text-brown-100/60 mb-5">
                                <ArrowPathIcon width="18" className="mr-2" /> Repeating Event
                            </div>
                            : null}

                        {isRegistrationRequired ? <h2 className="font-sans font-normal text-xs mt-2">Registration Required</h2> : null}

                        {registerUrl || infoUrl ?
                            <div className="mt-4 text-xs">
                                {infoUrl ?
                                    <a href={infoUrl} target="_blank" rel="noreferrer" className="flex">
                                        <InformationCircleIcon width={20} className="mr-2" /> More information
                                    </a>
                                    : null}
                                {registerUrl ?
                                    <>
                                        <a href={registerUrl} target="_blank" rel="noreferrer" className="flex">
                                            <TicketIcon width={20} className="mr-2" /> Buy tickets
                                        </a>
                                    </>
                                    : null}
                            </div>
                            : null}

                        {feeInfo ?
                            feeInfo.length > 80 ?
                                <SmallInfo title="test" dangerouslySetInnerHTML={{ __html: feeInfo.slice(0, 80) + `...` }} />
                                :
                                <SmallInfo title="Fees">{feeInfo}</SmallInfo>
                            : null}

                        {recurrenceDateStart || recurrenceDateEnd ?
                            <div>
                                <h2 className="uppercase text-xxs font-sans font-black text-green-100 mb-1">Date(s)</h2>
                                <p className="text-xs">
                                    {recurrenceDateStart ? formatDate(recurrenceDateStart) : null}
                                    {recurrenceDateStart !== '' && recurrenceDateEnd !== '' ? ' - ' : null}
                                    {recurrenceDateEnd ? formatDate(recurrenceDateEnd) : null}
                                </p>
                            </div> : null}

                        {timeStart || timeEnd ?
                            <div>
                                <h2 className="uppercase text-xxs font-sans font-black text-green-100 mb-1">Time</h2>
                                <p className="text-xs">
                                    {timeStart ? timeStart : null}
                                    {timeStart && timeEnd ? ' - ' : null}
                                    {timeEnd ? timeEnd : null}
                                </p>
                            </div> : null}
                    </div>
                </div>
            </main>

        </div>
    )
}

export async function getStaticProps({ params }) {
    let events = Object.values(eventData);

    let slug = params.slug;
    let eventItem = events && events.filter(event => event.slug === slug);
    let event = eventItem[0];

    return {
        props: { event },
        revalidate: 1,
    };
}

export async function getStaticPaths() {
    let events = Object.values(eventData);

    let allEventSlugs = events && events.filter(event => event.slug);
    return {
        paths: allEventSlugs.map(event => `/event/${event.slug}`) || [],
        fallback: 'blocking',
    };
}
